import { render, staticRenderFns } from "./NovaAssociacao.vue?vue&type=template&id=11a3f274"
import script from "./NovaAssociacao.vue?vue&type=script&lang=ts"
export * from "./NovaAssociacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports